export const getNew = () => ({
    totalTicketsSalesToday: 0,
    totalTicketsSoldToday: 0,
    totalTicketsSales: 0,
    totalTicketsSold: 0,
    totalTicketsAvailable: 0,
    totalTickets: 0,
    totalTicketsOnHold: 0,
    totalSalesLimit: 0,
});
export const fromGql = (item) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        totalTicketsSalesToday: (_a = item.totalTicketsSalesToday) !== null && _a !== void 0 ? _a : 0,
        totalTicketsSoldToday: (_b = item.totalTicketsSoldToday) !== null && _b !== void 0 ? _b : 0,
        totalTicketsSales: (_c = item.totalTicketsSales) !== null && _c !== void 0 ? _c : 0,
        totalTicketsSold: (_d = item.totalTicketsSold) !== null && _d !== void 0 ? _d : 0,
        totalTicketsAvailable: (_e = item.totalTicketsAvailable) !== null && _e !== void 0 ? _e : 0,
        totalTickets: (_f = item.totalTickets) !== null && _f !== void 0 ? _f : 0,
        totalTicketsOnHold: (_g = item.totalTicketsOnHold) !== null && _g !== void 0 ? _g : 0,
        totalSalesLimit: (_h = item.totalSalesLimit) !== null && _h !== void 0 ? _h : 0,
    });
};
export const fromGqlCollection = (items) => items.map(fromGql);
//# sourceMappingURL=EventSales.js.map